import React from 'react';

const About = () => {
    return (
        <div className="hero my-20 bg-base-200">
            <div className="hero-content text-center">
                <div className="max-w-md">
                    <p className="text-2xl font-bold text-orange-600">About Us</p>
                    <h1 className="text-5xl font-bold">Hello there</h1>
                    <p className="py-6">We Are providing the beast food in town. If you Ever Feel Hungry Feel free to contact us. </p>
                </div>
            </div>
        </div>
    );
};

export default About;